import { ASSIGN_ROOM_HOUSING_APPLICATIONS } from "../../../pages/student-life-page/housing/housing-periods/housingPeriodConstants";
import {
    ASSIGN_ROOM_SUCCESS,
    CLEAN_DEALLOCATE_STUDENTS,
    CLEAR_ROOM_ASSIGNMENT_RESPONSE,
    DEALLOCATE_ROOM_SUCCESS,
    NAVIGATE_TO_STEP,
    RESET_DEALLOCATE_ROOM_FINISH,
    SEARCH_ROOMS_RESET_FORM,
    SEARCH_ROOMS_SUCCESS,
    SEARCH_ROOMS_GET_PROPERTIES_FOR_HOUSING_PERIOD_SUCCESS,
    CLEAR_ROOM_SEARCH_RESULTS
} from "./housingRoomSearchActionTypes";

const initialState = {
    activeStep: ASSIGN_ROOM_HOUSING_APPLICATIONS,
    roomSearchResults: [],
    search: {
        campusId: null,
        propertyId: null,
        propertyTypeId: null,
        roomTypeId: null,
        roomStatus: 1,
        ageOperator: 'Between',
        ageRangeMax:null,
        ageRangeMin:null,
        programId: 0,
        gender: null,
        yearClassification: null,
        residentType: null,
        amenities: [],
        housingStaff: false,
        transferId: null,
        gpaOperator: 'GreaterThanOrEqual',
        gpaMaxValue: null,
        gpaMinValue: null,
        athleticsId: null,
        wheelchairAccesible: false,
        housingRateOperator: 'Between',
        housingRateRangeMax: null,
        housingRateRangeMin: null,
        roommateQuestionnaire: null
    },
    searchSelectItems:
    {
        housingPeriodProperties: []
    },
    roomAssignmentResults: null,
    isOpenPopUpRemoveStudents: false,
    studentsRemovedFromRoomModal: {
        students: [],
        deallocateRoomFinish: false
    }
};

const housingRoomSearchReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case SEARCH_ROOMS_GET_PROPERTIES_FOR_HOUSING_PERIOD_SUCCESS:
            return {
                ...state,
                searchSelectItems: {
                    housingPeriodProperties: payload
                }
            }
        case SEARCH_ROOMS_SUCCESS:
            return {
                ...state,
                roomSearchResults: payload
            }
        case SEARCH_ROOMS_RESET_FORM: 
            return { ...initialState }
        case ASSIGN_ROOM_SUCCESS:
            return {
                ...state,
                roomAssignmentResults: payload
            }
        case NAVIGATE_TO_STEP:
            return {
                ...state,
                activeStep: payload
            }
        case CLEAR_ROOM_ASSIGNMENT_RESPONSE:
            return {
                ...state,
                roomAssignmentResults: null,
                roomSearchResults: []
            }
        case CLEAN_DEALLOCATE_STUDENTS:
            return {
                ...state,
                studentsRemovedFromRoomModal: {
                    ...state.studentsRemovedFromRoomModal,
                    students: []
                }
            }
        case DEALLOCATE_ROOM_SUCCESS: 
            return {
                ...state,
                isOpenPopUpRemoveStudents: false,
                studentsRemovedFromRoomModal: {
                    ...state.studentsRemovedFromRoomModal,
                    deallocateRoomFinish: true,
                    students: []
                }
            }
        case RESET_DEALLOCATE_ROOM_FINISH:
            return {
                ...state,
                studentsRemovedFromRoomModal: {
                    ...state.studentsRemovedFromRoomModal,
                    deallocateRoomFinish: false,
                }
            }
        case CLEAR_ROOM_SEARCH_RESULTS:
            return {
                ...state,
                roomSearchResults: []
            }
        default:
            return state;
    }
}

export default housingRoomSearchReducer;